






































import Vue from "vue";
import Page from "@/components/Page.vue";
import eventBus from "@/services/eventBus";

import store, {PartnerPayDateStore} from "../services/PartnerPayDateStore"
import PartnerPayDateEdit from "../components/PartnerPayDateEdit.vue";

interface Data {
    store: PartnerPayDateStore;
    valid: boolean;
    eventBus: any;
}

interface Methods {
    updatePartnerPayDate(): void;
}
export default Vue.extend<Data, Methods, {}, {}>({
    components: {
        Page,
        PartnerPayDateEdit
    },

    data() {
        return {
            store,
            eventBus,
            valid: true,
        };
    },

    methods: {
        updatePartnerPayDate(): void {
            store.updatePartnerPayDate().then(r => eventBus.$emit("success", "Sikeres mentés"));
        }
    }
});
